import { SET_SOFTWARES, SET_MAILTEMPLATES } from "../actions/systemMgmtAction";


const defaultState = {
    softwares: [],
    mailtemplates: []
}

export const systemMgmtReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    switch (type) {
        case SET_SOFTWARES:
            return { ...state, softwares: data }
        case SET_MAILTEMPLATES:
            return { ...state, mailtemplates: data }
        default:
            return state;
    }
}